import { PASSWORD_MAX_LENGTH_RULE, PASSWORD_MIN_LENGTH_RULE, checkPasswordRules, } from '../domain/password-policy';
import { STAFF_LIMITS } from './staff-limits';
/**
 * PERSONEL ŞİFRESİ POLİTİKASI — TEK KAYNAK (panel kimliği ayrımı · Karar 3).
 *
 * Ürün politikasıyla AYNI BİÇİMİ kullanır (sıralı kural listesi) ama AYRI
 * listedir: personel şifresi uzunluktan ibarettir (taban 12, büyük harf ya da
 * sembol ŞARTI YOKTUR — kullanıcıya "en güvenlisi uzun bir cümle" denir).
 * Panel ekranlarının canlı kontrol listesi (`PasswordRuleList`) ve sunucunun
 * şeması (`staff-contracts.ts::staffPasswordSchema`) bu listeden okur; listeye
 * kural eklenirse ikisi birden değişir (elle test B-29).
 */
export const STAFF_PASSWORD_POLICY = {
    params: { min: STAFF_LIMITS.passwordMinLength, max: STAFF_LIMITS.passwordMaxLength },
    rules: [PASSWORD_MIN_LENGTH_RULE, PASSWORD_MAX_LENGTH_RULE],
};
export function checkStaffPasswordPolicy(password) {
    return checkPasswordRules(password, STAFF_PASSWORD_POLICY);
}
//# sourceMappingURL=staff-password-policy.js.map